import { render, staticRenderFns } from "./ParticipantExpiredWidget.vue?vue&type=template&id=652859c4"
import script from "./ParticipantExpiredWidget.vue?vue&type=script&lang=js"
export * from "./ParticipantExpiredWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports